import { render } from "./UserCabinetMenu.vue?vue&type=template&id=5877eed4&scoped=true"
import script from "./UserCabinetMenu.vue?vue&type=script&lang=js"
export * from "./UserCabinetMenu.vue?vue&type=script&lang=js"

import "./UserCabinetMenu.vue?vue&type=style&index=0&id=5877eed4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5877eed4"]])

export default __exports__